<ng-container>
    <div class="drowdown-start" (mouseleave)="showDropDown = false">
      <button class="drop-toggle btn flat" (click)="showDropDown=!showDropDown">
        <span *ngIf="checkedList.length<=0">{{title}}</span>
        <!-- <span *ngIf="checkedList.length>0">{{nameCheckedList.join(', ')}}</span> -->
        
        <i class="material-icons">
          expand_more
        </i>{{typeText}}
      </button>
      <div class="drop-show" *ngIf="showDropDown">
        <label *ngFor="let a of list">
            <input type="checkbox" [(ngModel)]="a.checked" 
                (change)="getSelectedValue(a.checked,a.name, a.value)"/>
            <span>{{a.name}}</span>
        </label>
    </div>
    </div>
  </ng-container>
